export const GET_AIRPORT_SUGGESTIONS =
  "https://www.latinofare.com/city_rjs.php?key=";
export const SEND_CALLBACK_REQUEST = 'https://airtkt.com/book/phn_ajax.php'
export const GET_FARE_TABLE_DATA = 'https://airtkt.com/book/fare_table_1.php'
export const GET_NEARBY_AIRPORT = 'https://airtkt.com/geo_nearby.php'
export const SEARCH_FLIGHTS = 'https://www.airtkt.com/book/book.php'
